// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadPrescription-module__container___nbHU2","content":"UploadPrescription-module__content___z+1g3","presIcon":"UploadPrescription-module__presIcon___iRGeW"};